import React from 'react';
import { NavLink } from 'react-router-dom';
import useAdminRole from '../../hooks/useAdminRole';

const ITEMS = [
  { to: '/dashboard', label: 'Dashboard', ico: '◆' },
  { to: '/invest',    label: 'Invest',    ico: '↑' },
  { to: '/team',      label: 'Team',      ico: '⚑' },
  { to: '/rewards',   label: 'Rewards',   ico: '★' },
  { to: '/history',   label: 'History',   ico: '≡' }
];

export default function Sidebar() {
  const { allowed: isAdmin } = useAdminRole();
  const items = isAdmin ? [...ITEMS, { to: '/admin', label: 'Admin', ico: '⚙' }] : ITEMS;

  return (
    <aside className="sidebar">
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}${it.to === '/admin' ? ' admin-item' : ''}`}
        >
          <span className="ico">{it.ico}</span>
          {it.label}
        </NavLink>
      ))}
    </aside>
  );
}
